import React from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  makeStyles,
  useTheme,
  Chip,
  CircularProgress,
  Tabs,
  Tab,
  Box,
  Typography,
  useMediaQuery,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  SvgIcon
} from "@material-ui/core";

import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';

import { alertRoutine } from "../../../redux/Alerts/routines";
import { store, i18n } from "../../../index";
import { history } from "../../../utils/configureStore";
import {
  getTagsPatientsRoutine,
  postPatientRoutinePromiseCreator,
  putPatientRoutinePromiseCreator,
} from "../../../redux/Patients/routines";
import { capitalizeName } from "../../../utils/string-helpers";
import { AjvValidatorContext } from "../../../utils/context/AjvContext";
import { patientSchema } from "./patientSchema";
import { useTranslation } from "react-i18next";
import PatientAvatar from "../../PatientAvatar";
import { KeyboardDatePicker, MuiPickersContext } from "@material-ui/pickers";
import { deletePatientFormActionCreator } from "./patientFormActionCreator";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { tagsIsLoadingSelector, tagsSelector } from "../../../redux/Patients/selectors";
//import { useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import { useLayoutEffect } from "react";
import RHFAutocompleteCorrespondants from "../../Correspondants/RHFAutocompleteCorrespondants";
import { makeParamsSelector } from "../../../redux/Params/selectors";
import { collectionKeysEqualityFn } from "../../../utils/equality";
import { CAISSE_PARAM_NAME, caisseLabel, caissesParamsFormActionCreator } from "../fiche-clinique/forms/caissesParamsFormActionCreator";
//import { correspondant } from "../../../redux/schemas";
import CustomSelectTextField from "../../Correspondants/MenuTextField";

const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));

const fieldTabMap = {
  // Onglet 0 : Patient
  civilite: 0,
  firstname: 0,
  lastname: 0,
  dateofbirth: 0,
  gender: 0,
  email: 0,
  phone: 0,
  adresse1: 0,
  adresse2: 0,
  postcode: 0,
  city: 0,
  collect_accept: 0,
  external_ids: 2,
  caisse: 2,
  healthcare_id: 0,

  // Onglet 1 : Assuré (uniquement si is_patient_assure = false)
  assure_civilite: 1,
  assure_firstname: 1,
  assure_lastname: 1,
  assure_gender: 1,
  assure_dateofbirth: 1,
  assure_healthcare_id: 1,
  assure_adresse1: 1,
  assure_adresse2: 1,
  assure_postcode: 1,
  assure_city: 1,
  assure_email: 1,
  assure_phone: 1,

  // Onglet 2 : Suivi
  tags: 2,
  correspondants: 2,
  recontact_date: 3,
};

const useStyles = makeStyles( theme => ({
  avatarRoot: {
    display: 'flex',
    justifyContent: 'center',
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  checkboxContainer: {
    "& .MuiFormControlLabel-label": {
      fontSize: theme.typography.body2.fontSize,
    }
  },
  buttonTextField: {
    "& .MuiInputAdornment-root button": {
      marginRight: -12
    }
  }
}));



const defaultValues = {

  //slide 1
  civilite: "",
  firstname: "",
  lastname: "",
  dateofbirth: null,
  gender: "",
  healthcare_id: "",
  is_patient_assure: true,
  email: "",
  phone: "",
  adresse1: "",
  adresse2: "",
  postcode: "",
  city: "",
  collect_accept: true, 

  //slide 2
  assure_civilite: "",
  assure_firstname: "",
  assure_lastname: "",
  assure_dateofbirth: null,
  assure_gender: "",
  assure_healthcare_id: "",
  assure_email: "",
  assure_phone: "",
  assure_adresse1: "",
  assure_adresse2: "",
  assure_postcode: "",
  assure_city: "",

  //slide 3
  tags: [],
  correspondants: [],
  categorie_traitement: "",
  caisse: null,
  external_ids: [],
  recontact_date: null,
}

export function filterPatientFormValues(patient) {
  if (!patient) return {};
  const formFields = Object.keys(defaultValues)
  return Object.fromEntries(
    Object.entries(patient).filter(([key]) => formFields.includes(key))//.filter(([key, value]) => !key.endsWith('dateofbirth') ? 1 : !value )
  );
}

// helper pour un panneau de tab
function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index} >
      {value === index && <Box pt={2}>{children}</Box>}
    </div>
  );
}

// --- Composant Formulaire ---
export function PatientDialog({
  open,
  handleClose,
  handleReject,
  alertId,
  opacity,
  patient,
  onSubmit,
  onDelete,
  hideBackdrop,
}) {
  console.log('PatientDialog alertId', alertId)
  const classes = useStyles();
  const { ajvResolver } = React.useContext(AjvValidatorContext);
  const { moment } = React.useContext(MuiPickersContext);
  const theme = useTheme()
  const options = useSelector(tagsSelector);
  const loading = useSelector(tagsIsLoadingSelector);
  const dispatch = useDispatch()

  // Options du champ « caisse » = référentiel caisses configuré (param caisse-list).
  const caisseParamsSelector = React.useMemo(makeParamsSelector, []);
  const caisseParams = useSelector(
    (state) => caisseParamsSelector(state, CAISSE_PARAM_NAME),
    collectionKeysEqualityFn(['id', 'updatedAt']),
  );
  const caisseOptions = React.useMemo(
    () => (caisseParams[0]?.value || [])
      .filter((c) => !c.archive)
      .sort((a, b) => {
        const fa = a.favorite ? 0 : 1;
        const fb = b.favorite ? 0 : 1;
        if (fa !== fb) return fa - fb;
        return String(a.libelle || '').localeCompare(String(b.libelle || ''));
      }),
    [caisseParams],
  );
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));

  React.useEffect(() => {
    dispatch(getTagsPatientsRoutine.trigger());
  }, [dispatch]);

  const getOptionLabel = (option) => {
    if (!option) return "";
    if (typeof option === "string") return option;
    if (typeof option === "object") return option.tag || "";
    return "";
  };

  const { t } = useTranslation()
  console.log('filterPatientFormValues(patient)', filterPatientFormValues(patient))
  const { control, handleSubmit, formState, watch, setValue } = useForm({
    resolver: ajvResolver(patientSchema),
    defaultValues: {...defaultValues, ...filterPatientFormValues(patient) } || defaultValues,
  });

  const firstname = watch('firstname');
  const lastname = watch('lastname');
  const is_patient_assure = watch('is_patient_assure');
  const correspondants = watch('correspondants');
  const tags = watch('tags');

  const avatarText = `${firstname?.trim()[0]?.toUpperCase() || ''}${lastname?.trim()[0]?.toUpperCase() || ''}` || null
  const external_ids = watch('external_ids') || [];

  const handleRemoveExternalLink = React.useCallback((link) => () => {
    const next = (external_ids || []).filter(l => !(l.service === link.service && l.id === link.id));
    setValue('external_ids', next, { shouldDirty: true, shouldValidate: false });
  }, [external_ids, setValue]);

  const [tab, setTab] = React.useState(0);
  const handleTabChange = (e, newValue) => setTab(newValue);

  const slides = [
    { 
      key: 'patient', 
      label: 'Patient', 
      content: (
        <Grid key="patient" container spacing={2}>
          {/* <Grid item xs={12} className={classes.avatarRoot}>
            {/*<Avatar className={classes.large}>{avatarText}</Avatar>*/}
            {/* <PatientAvatar className={classes.large} patient={patient} avatarText={avatarText}/>  */}
          {/* </Grid> */}
          <Grid item xs={12}>
            <CustomSelectTextField
              type="patient-civilite" 
              control={control}
              name={'civilite'} 
              variant="outlined" 
              size="small" 
              fullWidth
              label={t('patient.civilite')}
              error={Boolean(formState.errors.civilite)}
              helperText={formState.errors?.civilite?.message}
              actionTitle={t('patient.Modifier les civilités')}
              defaultItems={[
                t('patient.civilites.mrs'),
                t('patient.civilites.mr'),
                t("patient.civilites.child"),
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="firstname"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('form:patient.firstname')}
                  fullWidth
                  variant='outlined'
                  size="small"
                  margin="dense"
                  InputLabelProps={{
                    required: true
                  }}
                  autoComplete="new-password"
                  error={!!formState.errors.firstname}
                  helperText={formState.errors.firstname?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="lastname"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('form:patient.lastname')}
                  fullWidth
                  variant='outlined'
                  size="small"
                  margin="dense"
                  InputLabelProps={{
                    required: true
                  }}
                  autoComplete="new-password"
                  error={!!formState.errors.lastname}
                  helperText={formState.errors.lastname?.message}
                  
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="dateofbirth"
              control={control}
              render={({ field: { onChange, ref, ...field }, }) => (
                <KeyboardDatePicker
                  //disableToolbar
                  autoOk
                  //variant="inline"
                  inputVariant="outlined"
                  label={t('form:patient.dateofbirth')}
                  size="small"
                  margin="dense"
                  disableFuture
                  InputLabelProps={{
                    required: true
                  }}
                  inputProps={{
                    ref
                  }}
                  format={moment.localeData().longDateFormat('L')}
                  onChange={(date) => onChange(date? date.format('YYYY-MM-DD') : null)}
                  {...field}
                  // cancelLabel={t('common:button.cancel')}
                  // clearLabel={t('common:button.clear')}
                  // okLabel={t('common:button.ok')}
                  // showTodayButton={true}
                  // todayLabel={t('common:button.today')}
                  //className={classes.buttonTextField}
                  fullWidth
                  error={!!formState.errors.dateofbirth}
                  helperText={formState.errors.dateofbirth?.message}
                  cancelLabel={t('common:button.cancel')}
                  clearLabel={t('common:button.clear')}
                  okLabel={t('common:button.ok')}
                  todayLabel={t('common:button.today')}
                  className={classes.buttonTextField}
                />
                // <DatePicker
                //   {...field}
                //   label="Date de naissance"
                //   //type="date"
                //   InputLabelProps={{ shrink: true }}
                //   fullWidth
                //   error={!!formState.errors.dateofbirth}
                //   helperText={formState.errors.dateofbirth?.message}
                // />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="gender"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('form:patient.gender.label')}
                  placeholder=''  
                  select
                  fullWidth
                  error={!!formState.errors.gender}
                  helperText={formState.errors.gender?.message}
                  variant="outlined"
                  size="small"
                  margin="dense"
                  InputLabelProps={{
                    required: true
                  }}
                  SelectProps={{
                    native: true
                  }}
                >
                  {[
                      { value: ''  },
                      { value: 'male', label: t('form:patient.gender.male')},
                      { value: 'female', label: t('form:patient.gender.female')},
                    ].map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                  {/* <MenuItem value=""></MenuItem>
                  <MenuItem value="male">{t('form:patient.gender.male')}</MenuItem>
                  <MenuItem value="female">{t('form:patient.gender.female')}</MenuItem> */}
                </TextField>
              )}
            />
          </Grid>
          
          <Grid item xs={12} >
            <Controller
              name="healthcare_id"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("form:patient.healthcare_id")} // i18n : "Numéro d’assurance maladie"
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  error={!!formState.errors.healthcare_id}
                  helperText={formState.errors.healthcare_id?.message}
                />
              )}
            />
          </Grid>
          
          <Grid item xs={12} >
            <Controller
              name="is_patient_assure"
              control={control}
              render={({ field }) => (
                <FormControl component="fieldset" margin="dense">
                  <FormLabel component="legend" >
                    {t("form:patient.is_patient_assure")}
                  </FormLabel>
                  <RadioGroup
                    row
                    {...field}
                    value={field.value ? "yes" : "no"}
                    onChange={(e) => field.onChange(e.target.value === "yes")}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio color="primary" />}
                      label={t("common:yes")}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio color="primary" />}
                      label={t("common:no")}
                    />
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('form:patient.email')} 
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  className={classes.buttonTextField}
                  error={!!formState.errors.email}
                  helperText={formState.errors.email?.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            window.location = `mailto:${field.value}`
                          }

                        >
                          <MailOutlineIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t('form:patient.phone')} 
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  className={classes.buttonTextField}
                  error={!!formState.errors.phone}
                  helperText={formState.errors.phone?.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            window.location = `tel:${field.value}`
                          }
                        >
                          <PhoneIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="adresse1"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label={t('form:patient.adresse1')}
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  error={!!formState.errors.adresse1}
                  helperText={formState.errors.adresse1?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="adresse2"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label={t('form:patient.adresse2')} 
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  error={!!formState.errors.adresse2}
                  helperText={formState.errors.adresse2?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="postcode"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label={t('form:patient.postcode')} 
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  error={!!formState.errors.postcode}
                  helperText={formState.errors.postcode?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="city"
              control={control}
              render={({ field }) => (
                <TextField 
                  {...field} 
                  label={t('form:patient.city')} 
                  fullWidth
                  variant="outlined"
                  size="small"
                  margin="dense"
                  error={!!formState.errors.city}
                  helperText={formState.errors.city?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="collect_accept"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Checkbox {...field} checked={!!field.value} />}
                  label={t('form:patient.collect_accept')}
                />
              )}
            />
          </Grid>
        </Grid>
      ) 
    },
    ...(!is_patient_assure ? [
      { 
        key: 'assure', 
        label: 'Assuré', 
        content: (
          <Grid key="assure" container spacing={2}>
            {/* <Grid item xs={12} className={classes.avatarRoot}>
              {/*<Avatar className={classes.large}>{avatarText}</Avatar>*/}
              {/* <PatientAvatar className={classes.large} patient={patient} avatarText={avatarText}/>  */}
            {/* </Grid> */}
            <Grid item xs={12}>
              <CustomSelectTextField
                type="patient-civilite" 
                control={control}
                name={'assure_civilite'} 
                variant="outlined" 
                size="small" 
                fullWidth
                label={t('patient.civilite')}
                error={Boolean(formState.errors.assure_civilite)}
                helperText={formState.errors?.assure_civilite?.message}
                actionTitle={t('patient.Modifier les civilités')}
                defaultItems={[
                  t('patient.civilites.mrs'),
                  t('patient.civilites.mr'),
                  t("patient.civilites.child"),
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="assure_firstname"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form:patient.firstname')}
                    fullWidth
                    variant='outlined'
                    size="small"
                    margin="dense"
                    // InputLabelProps={{
                    //   required: true
                    // }}
                    autoComplete="new-password"
                    error={!!formState.errors.assure_firstname}
                    helperText={formState.errors.assure_firstname?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="assure_lastname"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form:patient.lastname')}
                    fullWidth
                    variant='outlined'
                    size="small"
                    margin="dense"
                    // InputLabelProps={{
                    //   required: true
                    // }}
                    autoComplete="new-password"
                    error={!!formState.errors.assure_lastname}
                    helperText={formState.errors.assure_lastname?.message}
                    
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="assure_dateofbirth"
                control={control}
                render={({ field: { onChange, ref,  ...field }, }) => (
                  <KeyboardDatePicker
                    //disableToolbar
                    autoOk
                    //variant="inline"
                    inputVariant="outlined"
                    label={t('form:patient.dateofbirth')}
                    size="small"
                    margin="dense"
                    disableFuture
                    // InputLabelProps={{
                    //   required: true
                    // }}
                    inputProps={{
                      ref
                    }}
                    format={moment.localeData().longDateFormat('L')}
                    onChange={(date) => onChange(date? date.format('YYYY-MM-DD') : null)}
                    {...field}
                    // cancelLabel={t('common:button.cancel')}
                    // clearLabel={t('common:button.clear')}
                    // okLabel={t('common:button.ok')}
                    // showTodayButton={true}
                    // todayLabel={t('common:button.today')}
                    //className={classes.buttonTextField}
                    fullWidth
                    error={!!formState.errors.assure_dateofbirth}
                    helperText={formState.errors.assure_dateofbirth?.message}
                    cancelLabel={t('common:button.cancel')}
                    clearLabel={t('common:button.clear')}
                    okLabel={t('common:button.ok')}
                    todayLabel={t('common:button.today')}
                    className={classes.buttonTextField}
                  />
                  // <DatePicker
                  //   {...field}
                  //   label="Date de naissance"
                  //   //type="date"
                  //   InputLabelProps={{ shrink: true }}
                  //   fullWidth
                  //   error={!!formState.errors.dateofbirth}
                  //   helperText={formState.errors.dateofbirth?.message}
                  // />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="assure_gender"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form:patient.gender.label')}
                    placeholder=''  
                    select
                    fullWidth
                    error={!!formState.errors.assure_gender}
                    helperText={formState.errors.assure_gender?.message}
                    variant="outlined"
                    size="small"
                    margin="dense"
                    // InputLabelProps={{
                    //   required: true
                    // }}
                    SelectProps={{
                      native: true
                    }}
                  >
                    {[
                        { value: ''  },
                        { value: 'male', label: t('form:patient.gender.male')},
                        { value: 'female', label: t('form:patient.gender.female')},
                      ].map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                    {/* <MenuItem value=""></MenuItem>
                    <MenuItem value="male">{t('form:patient.gender.male')}</MenuItem>
                    <MenuItem value="female">{t('form:patient.gender.female')}</MenuItem> */}
                  </TextField>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="assure_healthcare_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t("form:patient.healthcare_id")} // i18n : "Numéro d’assurance maladie"
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    error={!!formState.errors.assure_healthcare_id}
                    helperText={formState.errors.assure_healthcare_id?.message}
                  />
                )}
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Controller
                name="assure_email"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form:patient.email')} 
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    className={classes.buttonTextField}
                    error={!!formState.errors.assure_email}
                    helperText={formState.errors.assure_email?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              window.location = `mailto:${field.value}`
                            }

                          >
                            <MailOutlineIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="assure_phone"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form:patient.phone')} 
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    className={classes.buttonTextField}
                    error={!!formState.errors.assure_phone}
                    helperText={formState.errors.assure_phone?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              window.location = `tel:${field.value}`
                            }
                          >
                            <PhoneIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="assure_adresse1"
                control={control}
                render={({ field }) => (
                  <TextField 
                    {...field} 
                    label={t('form:patient.adresse1')}
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    error={!!formState.errors.assure_adresse1}
                    helperText={formState.errors.assure_adresse1?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="assure_adresse2"
                control={control}
                render={({ field }) => (
                  <TextField 
                    {...field} 
                    label={t('form:patient.adresse2')} 
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    error={!!formState.errors.assure_adresse2}
                    helperText={formState.errors.assure_adresse2?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="assure_postcode"
                control={control}
                render={({ field }) => (
                  <TextField 
                    {...field} 
                    label={t('form:patient.postcode')} 
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    error={!!formState.errors.assure_postcode}
                    helperText={formState.errors.assure_postcode?.message}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="assure_city"
                control={control}
                render={({ field }) => (
                  <TextField 
                    {...field} 
                    label={t('form:patient.city')} 
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin="dense"
                    error={!!formState.errors.assure_city}
                    helperText={formState.errors.assure_city?.message}
                  />
                )}
              />
            </Grid>

          </Grid>
        ) }
    ] : []),
    { 
      key: 'suivi', 
      label: 'Patient', 
      content: (
        <Grid key="suivi" container spacing={2}>
          {/* <Grid item xs={12} className={classes.avatarRoot}>
            {/*<Avatar className={classes.large}>{avatarText}</Avatar>*/}
            {/* <PatientAvatar className={classes.large} patient={patient} avatarText={avatarText}/>  */}
          {/* </Grid> */}
          <Grid item xs={12}>
            <Controller
              name="tags"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  multiple
                  freeSolo
                  disableClearable
                  options={options}
                  getOptionLabel={getOptionLabel}
                  value={field.value || []}
                  onChange={(event, newValue) => field.onChange(newValue.map(opt => typeof opt === 'string' ? opt : opt.tag))}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        style={{margin: 0}}
                        variant="outlined"
                        size="small"
                        label={getOptionLabel(option)}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("form:patient.tags.label")}
                      margin="dense"
                      error={!!formState.errors.tags}
                      helperText={formState.errors.tags?.find(elt => elt?.message)?.message}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        ...(loading && {endAdornment : <CircularProgress color="inherit" size={20} />}),
                        style: {gap: 4},
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <RHFAutocompleteCorrespondants
              name={"correspondants"}
              label={t("form:patient.correspondants")}
              fullWidth
              variant='outlined'
              size="small"
              margin="dense"
              autoComplete="new-password"
              alertId={alertId}
              control={control}
              error={!!formState.errors.correspondants}
              helperText={formState.errors.correspondants?.find(elt => elt?.message)?.message}
            />
          </Grid>
          {/* <Grid item xs={12}>
            NOTE : Ajouter un champ pour le praticien
          </Grid> */}
          <Grid item xs={12}>
            <CustomSelectTextField
              type="traitement-categorie"
              control={control}
              name={'categorie_traitement'}
              variant="outlined"
              size="small"
              fullWidth
              label={t('patient.categorie')}
              error={Boolean(formState.errors.categorie_traitement)}
              helperText={formState.errors?.categorie_traitement?.message}
              actionTitle={t('patient.Modifier les catégories')}
              defaultItems={[
                t('patient.traitement_categories.a_recontacter'),
                t('patient.traitement_categories.surveillance'),
                t('patient.traitement_categories.interception'),
                t('patient.traitement_categories.multi_attaches'),
                t('patient.traitement_categories.gouttieres'),
                t('patient.traitement_categories.lingual'),
                t('patient.traitement_categories.contention'),
                t('patient.traitement_categories.surveillance_dents_sagesse'),
                t('patient.traitement_categories.fin_de_traitement'),
                t('patient.traitement_categories.archive'),
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="caisse"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={caisseOptions}
                  groupBy={(option) => (option?.favorite ? 'Favoris' : 'Autres')}
                  getOptionLabel={(option) => caisseLabel(option)}
                  getOptionSelected={(opt, val) => opt?.id === val?.id}
                  value={field.value || null}
                  onChange={(event, newValue) => field.onChange(newValue || null)}
                  renderOption={(option) => (
                    <Box>
                      <Typography variant="body2">{option?.libelle}</Typography>
                      <Typography variant="caption" color="textSecondary">
                        {[option?.regime, option?.commune, option?.codePostal].filter(Boolean).join(' · ')}
                      </Typography>
                    </Box>
                  )}
                  noOptionsText={
                    <Box display="flex" flexDirection="column" alignItems="flex-start" style={{ gap: 4 }}>
                      <Typography variant="body2" color="textSecondary">
                        {caisseOptions.length ? 'Aucune caisse trouvée' : 'Aucune caisse configurée'}
                      </Typography>
                      <Button
                        size="small"
                        color="primary"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => dispatch(caissesParamsFormActionCreator())}
                      >
                        Ouvrir les paramètres de caisse
                      </Button>
                    </Box>
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Caisse"
                      margin="dense"
                      variant="outlined"
                      size="small"
                      error={!!formState.errors.caisse}
                      helperText={formState.errors.caisse?.message}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            {/* External links displayed as a non-editable multi-select with removable chips */}
            <Controller
              name="external_ids"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  multiple
                  disableClearable
                  
                  open={false}
                  options={field.value || []}
                  getOptionLabel={(option) => option?.name || option?.label || option?.service || ''}
                  getOptionSelected={(opt, val) => opt?.service === val?.service && opt?.id === val?.id}
                  value={field.value || []}
                  onChange={(event, newValue) => field.onChange(newValue)}
                  renderTags={(value, getTagProps) =>
                    value.map((link, index) => (
                      <Chip
                        variant="outlined"
                        size="small"
                        label={link?.name || link?.label || link?.service}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('form:patient.Liens externes')}
                      margin="dense"
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: undefined,
                        readOnly: true,
                        style: {gap: 4},
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
        </Grid>
      )
    },
    {
      key: 'dates',
      label: 'Dates',
      content: (
        <Grid key="dates" container spacing={2}>
          <Grid item xs={12}>
            <Controller
              name="recontact_date"
              control={control}
              render={({ field: { onChange, ref, ...field } }) => (
                <KeyboardDatePicker
                  autoOk
                  inputVariant="outlined"
                  label={t('form:patient.recontact_date')}
                  size="small"
                  margin="dense"
                  inputProps={{
                    ref
                  }}
                  format={moment.localeData().longDateFormat('L')}
                  onChange={(date) => onChange(date ? date.format('YYYY-MM-DD') : null)}
                  {...field}
                  fullWidth
                  error={!!formState.errors.recontact_date}
                  helperText={formState.errors.recontact_date?.message}
                  cancelLabel={t('common:button.cancel')}
                  clearLabel={t('common:button.clear')}
                  okLabel={t('common:button.ok')}
                  todayLabel={t('common:button.today')}
                  className={classes.buttonTextField}
                />
              )}
            />
          </Grid>
        </Grid>
      )
    },
  ];

  const slidesActions = React.useRef()

  useLayoutEffect(() => {
    console.log("useEffect isSM", slidesActions.current)
    if(slidesActions.current)
        slidesActions.current.updateHeight()
  }, [isSM, correspondants.length, tags.length, formState.errors])

  const errorFields = Object.keys(formState.errors);

  // set d’onglets en erreur
  const tabsWithError = new Set(
    errorFields
      .map((f) => fieldTabMap[f])
      .filter((i) => i !== undefined)
      .map((i) => (is_patient_assure ? (i > 0 ? i - 1 : i) : i))
  );
  const hasAssureTab = !is_patient_assure;
  const suiviTabIndex = hasAssureTab ? 2 : 1;
  const datesTabIndex = hasAssureTab ? 3 : 2;

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="sm" 
      fullWidth 
      scroll={fullScreen ? "paper" : "body"}
      fullScreen={fullScreen}
      PaperProps={{
        style: { opacity },
        component: "form",
        onSubmit: handleSubmit(onSubmit),
        autoComplete:"off",
      }}
      hideBackdrop={hideBackdrop}
      TransitionProps={{
        onExited: handleReject,
      }}
    >
      {/* <form onSubmit={handleSubmit(onSubmit)} autoComplete="new-password"> */}
        <DialogTitle>{t(patient?.id ? 'form:patient.title.edit' : 'form:patient.title.add')}</DialogTitle>
        <Grid container style={{padding: 4}}>
          <Grid item xs={12} className={classes.avatarRoot}>
            {/*<Avatar className={classes.large}>{avatarText}</Avatar>*/}
            <PatientAvatar className={classes.large} patient={patient} avatarText={avatarText}/> 
          </Grid>
        </Grid>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          // variant="fullWidth"
        >
          <Tab label={t("form:patient.tabs.patient")} style={tabsWithError.has(0) ? { color: "red" } : {}}/>
          {
              !is_patient_assure && 
            <Tab label={t("form:patient.tabs.assure")} disabled={is_patient_assure} style={tabsWithError.has(1) ? { color: "red" } : {}}/>
          }
          <Tab label={t("form:patient.tabs.suivi")} style={tabsWithError.has(suiviTabIndex) ? { color: "red" } : {}}/>
          <Tab label={t("form:patient.tabs.dates")} style={tabsWithError.has(datesTabIndex) ? { color: "red" } : {}}/>
        </Tabs>
        <DialogContent>
          <VirtualizeSwipeableViews
            index={tab}
            onChangeIndex={(i) => setTab(i)}
            animateHeight   // 👉 clé pour gérer la hauteur dynamique
            slideStyle={{ padding: 8 }}
            slideCount={slides.length}
            slideRenderer={({ index, key }) => {
              console.log('slideRenderer', index, key, slides[index])
              const slide = slides[index];
              return slide ? (
                <div key={slide.key}>
                  {slide.content}
                </div>
              ) : null;
            }}
            action={actions => {
               slidesActions.current = actions;
            }}
          />
            
           

        </DialogContent>

        <DialogActions style={{ display: "flex", justifyContent: "space-between" }}>
          {
            patient?.id ?
            <Button style={{color: theme.palette.error.main}} onClick={() => onDelete(alertId)} >
              {t('common:button.delete')}
            </Button> :
            <div/>
          }
          <div>
            <Button onClick={handleReject}>{t('common:button.cancel')}</Button>
            <Button type="submit" color="primary">
              {t('common:button.ok')}
            </Button>
          </div>
        </DialogActions>
      {/* </form> */}
    </Dialog>
  );
}

// --- Dialog RHF équivalent ---
export const patientFormActionCreator2 = (patient, parentAlertId) => {
  return alertRoutine.show({
    type: "full_dialog",
    parent: parentAlertId,
    neverHide: false,
    content: (props) => (
      <PatientDialog
        {...props}
        patient={patient}
        onSubmit={async (values) => {
          console.log('onSubmit', values);

          try {
            values.firstname = capitalizeName(values.firstname);
            values.lastname = values.lastname.toUpperCase();
            values.assure_firstname = capitalizeName(values.assure_firstname);
            values.assure_lastname = values.assure_lastname.toUpperCase();

            let promise;
            if (patient?.id) {
              promise = putPatientRoutinePromiseCreator(
                { values, id: patient.id },
                store.dispatch
              );
            } else {
              promise = postPatientRoutinePromiseCreator(
                { values },
                store.dispatch
              );
            }

            const { result } = await promise;
            if (!patient?.id) history.push(`/patient/${result}`);
            store.dispatch(alertRoutine.accept({ id: props.alertId }));
            return true;
          } catch (e) {
            store.dispatch(
              alertRoutine.show({
                type: "snack",
                title: i18n.t("common:interface.an error occured"),
                severity: "error",
              })
            );
            return false;
          }
        }}
        // onDelete={async () => {
        //   try {
        //     await deletePatientRoutinePromiseCreator(
        //       { id: patient.id },
        //       store.dispatch
        //     );
        //     history.push("/");
        //     store.dispatch(tabsPatientRoutine.close(patient.id));
        //     props.handleClose();
        //     return true;
        //   } catch (e) {
        //     store.dispatch(
        //       alertRoutine.show({
        //         type: "snack",
        //         title: i18n.t("common:interface.an error occured"),
        //         severity: "error",
        //       })
        //     );
        //     return false;
        //   }
        // }}
        onDelete={(alertId) => store.dispatch(deletePatientFormActionCreator(patient, alertId))}
      />
    ),
  });
};
